// JsFromRoutes CacheKey f00210cca13486e56a688e2517abb695
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_images/search'),
  duplicate: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_images/:id/duplicate'),
  duplicateSection: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_images/:id/duplicate_section'),
  appendToSection: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_images/:id/append_to_section'),
  typeahead: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_images/typeahead'),
  createInSection: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_images/create_in_section'),
  createInDuplicatedSection: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_images/create_in_duplicated_section'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_images'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_images'),
  new: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_images/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_images/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_images/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/hero_images/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/hero_images/:id'),
}
